module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAALCAYAAABGbhwYAAAAqUlEQVQoU4WRMQrCUBBE34BY6n1ElO+VLBQULCMWwcIDWKa0FKtYWtlZiwg2FhZCQNCVBD+EYJItd98sM7uyPRveBBpwoKJkMQ+gBUQ0GKvL5R/vwfZvmGCEwFyOZ15QBP3shpjSYy3xSZtloBecMIZybOtALwjrwCtillmwOPOgQtL0EguaLNUh8R4tB72AFUYgx72YOgXTrRHGRI5z2R13iJH6HKs+8wV+dj1Y94xkDwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/function/s.png
// module id = Gzu/
// module chunks = 1